// extracted by mini-css-extract-plugin
export default {"wrapper":"JjD5e1MMCxXYr7J_V06y","amount":"H3KZAELmsB29hNt9bHjS","description":"Dr_OJ6_Q2VcTQttzgnxC"};